// src/components/StyledComponents.js
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@mui/material/Button";
import styled from "styled-components";

export const PseudoLink = styled.a`
  color: ${(props) => props.styling.linkColor || "#007BFF"};
  cursor: pointer;
  text-decoration: none;
  margin-bottom: 0px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  &:hover {
    color: ${(props) => props.styling.linkHoverColor || "#0056b3"};
  }
`;

export const ClickableContainer = styled.div`
  cursor: pointer;
  background-color: #ffffff;
  color: ${(props) => (props.styling ? props.styling.textColor : "white")};
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
`;

export const StyledCard = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  transition: box-shadow 0.3s ease;
  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  float: left;
  width: 40%;
  max-width: 500px;
  margin-right: 20px;
  margin-bottom: 20px;
  margin-top: 10px;

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  @media (max-width: 768px) {
    float: none;
    width: 100%;
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
`;

export const ImageContainerAnsprechpartner = styled.div`
  margin-right: 20px;
  img {
    width: 120px;
    height: 160px;
    object-fit: cover;
    border-radius: 10px;
    border: none;
  }
`;

export const FullscreenIconContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: 0;
  transition: opacity 0.3s;
  cursor: pointer;
  color: ${(props) => props.styling?.navbarButtonBackgroundColor || "pink"};

  ${ImageContainer}:hover & {
    opacity: 1;
  }
`;

export const ContentContainer = styled.div`
  overflow: hidden;
  margin-bottom: 20px;

  h3 {
    margin-bottom: 20px; /* Increase spacing below the headline */
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 20px !important;
  background-color: ${(props) =>
    props.styling?.navbarButtonBackgroundColor || "#0077B5"};
  color: ${(props) => props.styling?.navbarButtonTextColor || "#fff"};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  width: 100%;
`;

export const FactText = styled.p`
  margin: 0;
  color: ${(props) => props.styling?.textColor || "#000"};
  font-family: ${(props) => props.styling?.fontFamily || "inherit"};
`;

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

export const LinkIcon = styled(FontAwesomeIcon)`
  margin-right: 10px;
  color: ${(props) => props.styling?.iconColor || "#0077B5"};
`;

export const LinkText = styled.a`
  color: ${(props) => props.styling?.linkColor || "#0077B5"};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const Name = styled.h2`
  margin: 0;
  color: #333;
  font-size: 1.5em;
`;

export const Role = styled.p`
  margin: 5px 0;
  color: #555;
  font-size: 1.1em;
`;

export const SocialMediaIcons = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
  flex-wrap: wrap;
`;

export const SocialMediaLink = styled.a`
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-bottom: 10px;
  text-decoration: none;
  color: inherit;
  font-size: 1.1em;

  .icon {
    margin-right: 5px;
    font-size: 1.5em;
  }
`;

export const EmailLink = styled.a`
  display: flex;
  align-items: center;
  margin-top: 10px;
  text-decoration: none;
  color: ${(props) => props.linkColor || "#0077B5"};
  font-size: 1.1em;
`;

export const GalleryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

export const GalleryItem = styled.div`
  width: 200px;
  margin: 10px;
  cursor: pointer;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    background-color: #e0e0e0;
  }
`;

export const GalleryImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const SkeletonItem = styled.div`
  width: 100%;
  height: 180px;
  border-radius: 4px;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HtmlRendererContainer = styled.div`
  text-align: justify;
`;

export const ClearFix = styled.div`
  clear: both;
`;

export const Section = styled.div`
  margin-top: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h4`
  display: flex;
  align-items: center;
  font-size: 20px;
  margin-bottom: 15px;
  color: ${(props) => props.styling?.textColor || "#333"};
  font-family: ${(props) => props.styling?.fontFamily || "inherit"};
`;

export const KeywordContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
`;

export const Keyword = styled.span`
  background-color: ${(props) =>
    props.styling?.keywordBackgroundColor || "#0077B5"};
  color: ${(props) => props.styling?.textColor || "#fff"};
  border-radius: 16px;
  padding: 8px 16px;
  margin: 5px;
  font-family: ${(props) => props.styling?.fontFamily || "inherit"};
  font-size: 14px;
`;

export const Category = styled.span`
  background-color: ${(props) =>
    props.styling?.categoryBackgroundColor || "#0077B5"};
  color: ${(props) => props.styling?.textColor || "#fff"};
  border-radius: 16px;
  padding: 8px 16px;
  margin: 5px;
  font-family: ${(props) => props.styling?.fontFamily || "inherit"};
  font-size: 14px;
`;

export const StyledIconWrapper = styled.span`
  margin-right: 10px !important;
  color: ${(props) => props.styling?.iconColor || "blue"};
`;

export const OverlayImage = styled.img`
  width: 100%;
  max-height: 60vh;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  object-fit: contain; 
`;


export const StyledSmallButton = styled(Button)`
  margin: 10px !important;
  background-color: ${(props) =>
    props.styling?.smallButtonBackgroundColor || "#666"};
  color: ${(props) => props.styling?.smallButtonTextColor || "#fff"};
  font-size: 0.8rem;
  padding: 5px 10px;
`;

export const ApplyButton = styled(StyledButton)`
  background-color: ${(props) =>
    props.styling?.applyButtonBackgroundColor || "#d32f2f"};
  color: ${(props) => props.styling?.linkColor || "#fff"};
  &:hover {
    background-color: ${(props) =>
      props.styling?.applyButtonHoverBackgroundColor || "#c62828"};
  }
`;

export const TextElement = styled.p`
  color: ${(props) => props.styling?.textColor || "#333"};
`;

export const TitleElement = styled.h3`
  color: ${(props) => props.styling?.textColor || "#333"};
`;
